var InitalizeCriteria = function () {
    $('.nthLink').click(function() {
        jQuery.DotComAjax({
            url: "/Ajax/AllowNth",
            cache: false,
            success: function (response) {
                if (response.Data.AllowNth) {
                    window.location = response.Data.Url;
                } else {
                    $('#nth-selection-help').click();
                }
            }
        });
    });
};



